module.exports = __webpack_public_path__ + "img/queen.533c0db3.png";